export const TRIGGER_NAVBAR = 'TRIGGER_NAVBAR';
export const triggerNavbar = () => {
    return {
        type: TRIGGER_NAVBAR
    }
}

